
import { Dispatch, SetStateAction, createContext } from "react";

import { SiteEventType } from "../../api/dtos/dtos";

export type RecordToEdit = {
    siteEventType: SiteEventType,
    recordId: number,
    hasImage?: boolean
}

interface IMapFormContext {
    drawerOpen: boolean;
    siteEventType?: SiteEventType;
    viewHistoryRoot?: number;
    viewHistorySiteEventType?: SiteEventType;
    mapFormData?: Record<string, any>;
    drawerMaximised: boolean;
    selectingLocationCoords?: { lat: number, lng: number };
    recordToEdit: RecordToEdit | null;
    subSpecies?: string;
    imageGuid?: string;
    openDrawer: () => void;
    closeDrawer: () => void;
    minimiseDrawer: () => void;
    maximiseDrawer: () => void;
    setViewHistoryRoot: Dispatch<SetStateAction<number | undefined>>;
    setViewHistorySiteEventType: Dispatch<SetStateAction<SiteEventType | undefined>>;
    setSiteEventType: Dispatch<SetStateAction<SiteEventType | undefined>>;
    setMapFormData: Dispatch<SetStateAction<Record<string, any>>>;
    setSelectingLocationCoords: Dispatch<SetStateAction<{ lat: number, lng: number } | undefined>>;
    setRecordToEdit: Dispatch<SetStateAction<RecordToEdit | null>>;
    setSubSpecies: Dispatch<SetStateAction<string | undefined>>;
    setImageGuid: Dispatch<SetStateAction<string | undefined>>;
}

export const MapFormContext = createContext<IMapFormContext>({
    drawerOpen: false,
    siteEventType: undefined,
    viewHistoryRoot: undefined,
    viewHistorySiteEventType: undefined,
    mapFormData: {},
    drawerMaximised: false,
    selectingLocationCoords: undefined,
    recordToEdit: null,
    subSpecies: undefined,
    imageGuid: undefined,
    openDrawer: () => {},
    closeDrawer: () => {},
    minimiseDrawer: () => {},
    maximiseDrawer: () => {},
    setViewHistoryRoot: () => {},
    setViewHistorySiteEventType: () => {},
    setSiteEventType: () => {},
    setMapFormData: () => {},
    setSelectingLocationCoords: () => {},
    setRecordToEdit: () => {},
    setSubSpecies: () => {},
    setImageGuid: () => {}
});

export default MapFormContext;